import { useVisibleAccountOrders } from 'src/hooks/query/accountTradingData/useVisibleOrders';

/**
 * The number of open orders that are visible to the user. This is the number of open
 * orders that are not expired.
 *
 * This is different from the total open order count because it does not include expired
 * orders. This is useful because it allows us to show the user the number of open orders
 * that are currently visible to them, which is more useful than the total open order count.
 *
 * @returns The number of visible open orders.
 */
export const useVisibleOpenOrderCount = () => useVisibleAccountOrders().length;
